import * as React from "react"
import MuiBox from "@mui/material/Box"
// import { BoxProps as MuiBoxProps } from "@mui/material"

// export interface BoxProps extends MuiBoxProps {}

export default function Box(props: any) {
  return <MuiBox {...props} />
}
